// frontend/src/components/ESIMPackages/FilterPanel.js
import React from "react";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const FilterPanel = ({ filters, onFilterChange, regions = [] }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          fullWidth
          label={t("esim.packages.filters.name")}
          value={filters.name}
          onChange={onFilterChange("name")}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          select
          label={t("esim.packages.filters.region")}
          value={filters.region}
          onChange={onFilterChange("region")}
        >
          <MenuItem value="">{t("esim.packages.filters.allRegions")}</MenuItem>
          {regions.map((region) => (
            <MenuItem key={region} value={region}>
              {region}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          label={t("esim.packages.filters.duration")}
          value={filters.duration}
          onChange={onFilterChange("duration")}
          type="number"
          inputProps={{ min: 0 }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <TextField
              fullWidth
              label={t("esim.packages.filters.data")}
              value={filters.data}
              onChange={onFilterChange("data")}
              type="number"
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={4}>
            <Select
              fullWidth
              value={filters.unit}
              onChange={onFilterChange("unit")}
              sx={{ height: "100%" }}
            >
              <MenuItem value="GB">GB</MenuItem>
              <MenuItem value="MB">MB</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterPanel;
